export enum GetDesignTokensErrorReason {
  STYLING_PARAMETERS_NOT_FOUND = "stylingParametersNotFound",
  CONFIGURATIONS_NOT_FOUND = "configurationsNotFound",
  CONTENT_FILTERING_CONFIGURATIONS_NOT_FOUND = "contentFilteringConfigurationsNotFound",
}
